import { licenseCheckResponseData, licenseStatuses } from '../../../../backend/extraTypes';
import { LicenseCheckRequestSchema } from '@juvare/platform-app/Integration';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const licenseCheckLatestStatusEntityName = 'licenseCheckLatestStatus';
export const licenseCheckLatestStatusSchema = z.object({
    personId: z.string().uuid(),
    occupationId: z.string().uuid(),
    credentialId: z.string().uuid(),
    licenseId: z.string().uuid(),
    status: z.enum(licenseStatuses),
    requestDate: z.number().optional(),
    requestedBy: z.string().optional(),
    internalPersonName: z.string().optional(),
});
export const licenseCheckLatestStatusColumns = defineColumns({
    personId: {
        type: 'id-required',
        index: true,
    },
    occupationId: {
        type: 'id-required',
        index: true,
    },
    credentialId: {
        type: 'id-required',
        index: true,
    },
    jasBoard: {
        type: 'boolean-required',
        index: true,
    },
    licenseId: {
        type: 'id-required',
        index: 'unique',
    },
    status: {
        type: 'string-required',
        index: true,
    },
    personName: {
        type: 'string-required',
    },
    occupationName: {
        type: 'string-required',
    },
    requestDate: {
        type: 'number',
    },
    requestedBy: {
        type: 'string',
    },
    credentialName: {
        type: 'string-required',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
export const licenseCheckHistoryEntityName = 'licenseCheckHistory';
export const licenseCheckHistorySchema = z.object({
    personId: z.string().uuid(),
    occupationId: z.string().uuid(),
    credentialId: z.string().uuid(),
    licenseId: z.string().uuid(),
    response: licenseCheckResponseData.optional(),
    messageId: z.string().optional(),
    status: z.enum(licenseStatuses),
    internalStatusChange: z.boolean().optional(),
    request: LicenseCheckRequestSchema.optional(),
    requestDate: z.number().optional(),
    requestedBy: z.string().optional(),
});
export const licenseCheckHistoryColumns = defineColumns({
    personId: {
        type: 'id-required',
        index: true,
    },
    messageId: {
        type: 'id',
        index: true,
    },
});
